import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { extractDate } from "../../Components/Functions/date.fun";
import { FcCurrencyExchange } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";

const ViewFarmingConference = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/thefarmingconference/view-farmingconference/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting employee feedback!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const colourCode = (status) => {
    if (status === "success") {
      return "status status-green border rounded-2 p-2";
    } else {
      return "status status-red border rounded-2 p-2";
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCurrencyExchange className="fs-2 me-1" />
                  View Farming Conference
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Farming Conference Details</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Payment Id :</label>
                  <div className="w-100 col">{data?.payment_id || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Name :</label>
                  <div className="w-100 col">{data?.name || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Email :</label>
                  <div className="w-100 col">{data?.email || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Contact No :</label>
                  <div className="w-100 col">{data?.phone || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Amount :</label>
                  <div className="w-100 col">₹{data?.amount || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Payment Status :
                  </label>
                  <div
                    className={`w-100 col text-uppercase ${colourCode(
                      data?.status
                    )}`}
                  >
                    {data?.status || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">City :</label>
                  <div className="w-100 col">{data?.city || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Country :</label>
                  <div className="w-100 col">{data?.country || "N/A"}</div>
                </div>
              )}

              <div>
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Purpose :</label>
                  {data?.purpose?.map((item, index) => {
                    return (
                      <div className="w-100 col" key={index}>
                        {item?.purpose || "N/A"}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewFarmingConference;
